export { default } from './threeCardsWithImage'
